import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getUnsubscribeFromNotificationKey } from '../../utils/keys';
export const useUnsubscribeFromNotification = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    return useMutation(input => client.notifications.unsubscribe(input), {
        mutationKey: getUnsubscribeFromNotificationKey(),
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUnsubscribeFromNotification.js.map